export const FeedbackQuestions = [
  {
    id:"1",
    type: "radio",
    question: "Would you like to learn more about this topic?",
    options: ["Yes", "No"],
  },
  {
    id:"2",
    type: "radio",
    question: "Please Rate the Speaker's Knowledge of the topic?",
    options: ["Excellent", "Good", "Fair", "Poor"],
  },
  {
    id:"3",
    type: "radio",
    question: "Overall session evaluation?",
    options: ["Excellent", "Good", "Fair", "Poor"],
  },
  {
    id:"4",
    type: "radio",
    question: "Please Rate your overall experience?",
    options: ["Excellent", "Good", "Fair", "Poor"],
  },
];
